import axios from "axios";

const endpoint_url = "/message/whatsappTemplate/create";

const createWhatsappTemplate = (requestBody) => {
  return new Promise((resolve, reject) => {
    axios
      .post(endpoint_url, requestBody)
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default createWhatsappTemplate;
